<!--=========================
=            FAQ            =
==========================-->
<template>
  <div>
    <v-row>
      <base-header>
        <div slot="page-header">FAQ</div>
      </base-header>
    </v-row>
    <v-row>
      <template>
        
        <v-col cols="12" md="12" sm="12">
          <base-card>
            <div slot="card-header">

            Frequently Ask Questions
            </div>
            <div slot="card-subheader"> Amet duis incididunt laboris irure ipsum et in eiusmod incididunt id ex fugiat
              reprehenderit. </div>
            <div slot="card-body">
              <v-expansion-panels focusable>
                <v-expansion-panel class="elevation-0 mb-5">

                  <v-expansion-panel-header class="font-weight-bold subtitle-1" expand-icon="mdi-menu-down">
                    How to Contatct Your Finance Office?
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                    sed do eiusmod
                    tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,
                    quis nostrud
                    exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
              <v-expansion-panels focusable>
                <v-expansion-panel class="elevation-0 mb-5">

                  <v-expansion-panel-header class="font-weight-bold subtitle-1" expand-icon="mdi-menu-down">
                    Change Tax Account on Virtue
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                    sed do eiusmod
                    tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,
                    quis nostrud
                    exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
              <v-expansion-panels focusable>
                <v-expansion-panel class="elevation-0 mb-5">

                  <v-expansion-panel-header class="font-weight-bold subtitle-1" expand-icon="mdi-menu-down">
                    Reset Password with phone number
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                    sed do eiusmod
                    tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,
                    quis nostrud
                    exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </div>
          </base-card>
        </v-col>
        <v-col cols="12" md="12" sm="12">
          <base-card>
            <div slot="card-header">

             Frequently Ask Questions
            </div>
            <div slot="card-subheader"> Amet duis incididunt laboris irure ipsum et in eiusmod incididunt id ex fugiat
              reprehenderit. </div>
            <div slot="card-body">
              <v-expansion-panels focusable>
                <v-expansion-panel class="elevation-0 mb-5">

                  <v-expansion-panel-header class="font-weight-bold subtitle-1" expand-icon="mdi-menu-down">
                    How to Contatct Your Finance Office?
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                    sed do eiusmod
                    tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,
                    quis nostrud
                    exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
              <v-expansion-panels focusable>
                <v-expansion-panel class="elevation-0 mb-5">

                  <v-expansion-panel-header class="font-weight-bold subtitle-1" expand-icon="mdi-menu-down">
                    Change Tax Account on Virtue
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                    sed do eiusmod
                    tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,
                    quis nostrud
                    exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
              <v-expansion-panels focusable>
                <v-expansion-panel class="elevation-0 mb-5">

                  <v-expansion-panel-header class="font-weight-bold subtitle-1" expand-icon="mdi-menu-down">
                    Reset Password with phone number
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                    sed do eiusmod
                    tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,
                    quis nostrud
                    exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </div>
          </base-card>
        </v-col>
         <v-col cols="12" md="12" sm="12">
          <base-card>
            <div slot="card-header">

             Frequently Ask Questions
            </div>
            <div slot="card-subheader"> Amet duis incididunt laboris irure ipsum et in eiusmod incididunt id ex fugiat
              reprehenderit. </div>
            <div slot="card-body">
              <v-expansion-panels focusable>
                <v-expansion-panel class="elevation-0 mb-5">

                  <v-expansion-panel-header class="font-weight-bold subtitle-1" expand-icon="mdi-menu-down">
                    How to Contatct Your Finance Office?
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                    sed do eiusmod
                    tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,
                    quis nostrud
                    exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
              <v-expansion-panels focusable>
                <v-expansion-panel class="elevation-0 mb-5">

                  <v-expansion-panel-header class="font-weight-bold subtitle-1" expand-icon="mdi-menu-down">
                    Change Tax Account on Virtue
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                    sed do eiusmod
                    tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,
                    quis nostrud
                    exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
              <v-expansion-panels focusable>
                <v-expansion-panel class="elevation-0 mb-5">

                  <v-expansion-panel-header class="font-weight-bold subtitle-1" expand-icon="mdi-menu-down">
                    Reset Password with phone number
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                    sed do eiusmod
                    tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,
                    quis nostrud
                    exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </div>
          </base-card>
        </v-col>
       
      </template>
    </v-row>

  </div>

</template>
<script>
  import BaseCard from "../../components/Base/BaseCard.vue";
  import BaseHeader from '../../components/Base/BaseHeader'
  export default {
    components: {
      BaseCard,
      BaseHeader
    },

  }
</script>


<!--====  End of FAQ  ====-->
